<template>
  <div>
    <v-btn
      color="#29284c"
      class="white--text"
      width="100"
      :disabled="disabled"
      depressed
      @click="onConfirm"
    >
      <v-fade-transition leave-absolute>
        <v-icon v-if="value" size="26">mdi-alert</v-icon>
        <span v-else>
          <slot name="text"> Save </slot>
        </span>
      </v-fade-transition>
    </v-btn>
    <v-snackbar :value="value" @input="$emit('input', $event)" fixed color="white">
      <v-icon left size="36" color="#29284c">mdi-alert</v-icon>
      <span class="custom-text title">{{ snackbarText }}</span>
      <v-btn icon color="#29284c" text @click="$emit('input', false)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <ConfirmDialog :value="confirmDialog" @input="confirmDialog = $event" @yes="onYes">
      <template #title>
        <v-card-title> Confirmation Required! </v-card-title>
      </template>
      <template #text>
        <v-card-text>
          {{ confirmText }}
        </v-card-text>
      </template>
    </ConfirmDialog>
  </div>
</template>
<script>
import ConfirmDialog from "@/components/ConfirmDialog.vue";

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    value: Boolean,
    snackbarText: String,
    disabled: Boolean,
    confirmText: String,
  },
  data() {
    return {
      confirmDialog: false,
    };
  },
  methods: {
    onConfirm() {
      if (this.confirmText) {
        this.confirmDialog = true;
      } else {
        this.$emit("click");
      }
    },
    onYes() {
      this.$emit("click");
      this.confirmDialog = false;
    },
  },
};
</script>
